/** CoStar.Api.Professional.Companies.CompanySortType */
export var CompanySortType;
(function (CompanySortType) {
    CompanySortType[CompanySortType["None"] = 0] = "None";
    CompanySortType[CompanySortType["Address"] = 1] = "Address";
    CompanySortType[CompanySortType["City"] = 3] = "City";
    CompanySortType[CompanySortType["CompanyName"] = 5] = "CompanyName";
    CompanySortType[CompanySortType["CoStarProductMarket"] = 9] = "CoStarProductMarket";
    CompanySortType[CompanySortType["LeaseListingCount"] = 13] = "LeaseListingCount";
    CompanySortType[CompanySortType["LeaseTransactionCount3Year"] = 15] = "LeaseTransactionCount3Year";
    CompanySortType[CompanySortType["ManagedPropertyCount"] = 19] = "ManagedPropertyCount";
    CompanySortType[CompanySortType["OperatedPropertyCount"] = 23] = "OperatedPropertyCount";
    CompanySortType[CompanySortType["OwnedPropertyCount"] = 25] = "OwnedPropertyCount";
    CompanySortType[CompanySortType["PrimarySpecialtyID"] = 29] = "PrimarySpecialtyID";
    CompanySortType[CompanySortType["SaleListingCount"] = 31] = "SaleListingCount";
    CompanySortType[CompanySortType["SaleTransactionCount3Year"] = 33] = "SaleTransactionCount3Year";
    CompanySortType[CompanySortType["State"] = 35] = "State";
    CompanySortType[CompanySortType["TotalEmployees"] = 37] = "TotalEmployees";
    CompanySortType[CompanySortType["Country"] = 39] = "Country";
    CompanySortType[CompanySortType["NumberOfOffices"] = 41] = "NumberOfOffices";
    CompanySortType[CompanySortType["BuildingName"] = 43] = "BuildingName";
    CompanySortType[CompanySortType["LeaseTransactionSF3Year"] = 47] = "LeaseTransactionSF3Year";
    CompanySortType[CompanySortType["RentableBuildingSF"] = 49] = "RentableBuildingSF";
    CompanySortType[CompanySortType["LeaseListingAvailableSF"] = 51] = "LeaseListingAvailableSF";
    CompanySortType[CompanySortType["SaleTransactionSF3Year"] = 53] = "SaleTransactionSF3Year";
    CompanySortType[CompanySortType["SaleTransactionVolume3YearUSD"] = 55] = "SaleTransactionVolume3YearUSD";
    CompanySortType[CompanySortType["SaleListingSF"] = 57] = "SaleListingSF";
    CompanySortType[CompanySortType["ArticleCount"] = 67] = "ArticleCount";
})(CompanySortType || (CompanySortType = {}));
